(function () {
  const selectors = {
    root: '[data-nazva-product-bundles]',
    track: '[data-nazva-bundle-track]',
    slide: '[data-nazva-bundle-slide]',
    prev: '[data-nazva-bundle-prev]',
    next: '[data-nazva-bundle-next]',
    dot: '[data-nazva-bundle-dot]',
    summary: '[data-nazva-bundle-summary]',
    add: '[data-nazva-bundle-add]',
    product: '[data-nazva-bundle-product]',
    variant: '[data-nazva-bundle-variant]',
    options: '[data-nazva-bundle-options]',
    price: '[data-nazva-bundle-price]',
    compare: '[data-nazva-bundle-compare]',
    productPriceCurrent: '[data-nazva-bundle-price-current]',
  };

  const formatMoney = (cents, currency, locale) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'EUR',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      }).format(amount);
    } catch (error) {
      const symbolMap = {
        EUR: '€',
        USD: '$',
        GBP: '£',
        UAH: '₴',
      };
      const symbol = symbolMap[(currency || '').toUpperCase()] || (currency || '');
      return `${symbol}${amount.toFixed(Number.isInteger(amount) ? 0 : 2)}`.trim();
    }
  };

  const isInteractiveBundleTarget = (target) =>
    Boolean(
      target?.closest(
        'button, input, label, select, textarea, summary, [role="button"], .nazva-bundle-product__actions, .nazva-bundle-product__options'
      )
    );

  const getSelectedVariant = (productElement) => {
    const checked = productElement.querySelector(`${selectors.variant}:checked`);
    if (checked) return checked;
    const hidden = productElement.querySelector(`${selectors.variant}[type="hidden"]`);
    return hidden || null;
  };

  const getSlideProducts = (slide) => Array.from(slide.querySelectorAll(selectors.product));

  const getSlideSummary = (root, slide) => {
    const bundleId = slide?.dataset.bundleId;
    if (!bundleId) return null;
    return root.querySelector(`${selectors.summary}[data-bundle-id="${CSS.escape(bundleId)}"]`);
  };

  const calculateSlide = (root, slide) => {
    const products = getSlideProducts(slide);
    const summary = getSlideSummary(root, slide) || slide;
    const selectedVariants = products.map(getSelectedVariant);
    const hasMissingVariant = selectedVariants.some((variant) => !variant || !variant.value);
    const currency = root.dataset.currency;
    const locale = root.dataset.locale;
    const regularTotal = selectedVariants.reduce((total, variant) => total + Number(variant?.dataset.price || 0), 0);
    const configuredPrice = Number(slide.dataset.configuredPrice || 0);
    const discountPercent = Number(slide.dataset.discountPercent || 5);
    const bundleTotal = configuredPrice > 0 ? configuredPrice : Math.round(regularTotal * (100 - discountPercent) / 100);
    summary.querySelector(selectors.price).textContent = formatMoney(bundleTotal, currency, locale);
    summary.querySelector(selectors.compare).textContent = formatMoney(regularTotal, currency, locale);

    selectedVariants.forEach((variant, index) => {
      const productElement = products[index];
      const priceElement = productElement?.querySelector(selectors.productPriceCurrent);
      if (!productElement || !priceElement || !variant) return;
      priceElement.textContent = formatMoney(Number(variant.dataset.price || 0), currency, locale);
    });

    const addButton = summary.querySelector(selectors.add);
    if (addButton) {
      addButton.dataset.bundlePrice = String(bundleTotal);
      addButton.dataset.bundleCompare = String(regularTotal);
      addButton.classList.toggle('is-waiting-for-options', hasMissingVariant);
    }
  };

  const showMissingOptions = (slide) => {
    getSlideProducts(slide).forEach((productElement) => {
      if (getSelectedVariant(productElement)) return;
      const options = productElement.querySelector(selectors.options);
      options?.classList.remove('hidden');
      productElement.classList.add('has-missing-options');
    });
  };

  const addBundleToCart = (root, slide, button) => {
    const products = getSlideProducts(slide);
    const selectedVariants = products.map(getSelectedVariant);

    if (selectedVariants.some((variant) => !variant || !variant.value)) {
      showMissingOptions(slide);
      return;
    }

    const bundleId = slide.dataset.bundleId || `${Date.now()}`;
    const bundleTitle = button.dataset.bundleTitle || 'Product bundle';
    const bundlePrice = button.dataset.bundlePrice || '';
    const bundleCompare = button.dataset.bundleCompare || '';
    
    let items = selectedVariants.map((variant, index) => ({
      id: Number(variant.value),
      quantity: 1,
      properties: {
        _nazva_bundle_id: bundleId,
        _nazva_bundle_title: bundleTitle,
        _nazva_bundle_price: bundlePrice,
        _nazva_bundle_compare: bundleCompare,
        _nazva_bundle_position: String(index + 1),
      },
    }));

    const bundleVariantsJSON = slide.dataset.bundleProductVariants;
    if (bundleVariantsJSON) {
      try {
        const bundleVariants = JSON.parse(bundleVariantsJSON);
        const selectedOptionValues = selectedVariants.flatMap(v => {
          if (!v.dataset.title || v.dataset.title === 'Default Title') return [];
          return v.dataset.title.split(' / ');
        });
        const uniqueSelected = Array.from(new Set(selectedOptionValues)).sort().join('|');

        const matchingBundleVariant = bundleVariants.find(bv => {
          if (!bv.title || bv.title === 'Default Title') return true;
          const bvOptions = bv.title.split(' / ');
          return bvOptions.every(opt => selectedOptionValues.includes(opt));
        });

        if (matchingBundleVariant) {
            const img1 = selectedVariants[0] && selectedVariants[0].dataset.image ? selectedVariants[0].dataset.image : '';
            const img2 = selectedVariants[1] && selectedVariants[1].dataset.image ? selectedVariants[1].dataset.image : '';

            items = [{
              id: matchingBundleVariant.id,
              quantity: 1,
              properties: {
                '_bundle_image_1': img1,
                '_bundle_image_2': img2
              }
            }];
          } else {
          console.warn('Could not find matching bundle variant, falling back to components.');
        }
      } catch (e) {
        console.error('Failed to parse bundle product variants', e);
      }
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    let payload = { items };

    if (cart) {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.setActiveElement(button);
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    fetch(`${routes.cart_add_url}.js`, {
      ...config,
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || 'Unable to add bundle');
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (response.sections) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items', // Prevent redundant GET
            cartData: response,
          });
          cart.renderContents(response);
        } else {
          // Fallback: manually fetch sections with cache-busting, with a delay for Bundle unpacking
          setTimeout(() => {
            const sectionsToRender = cart.getSectionsToRender().map((section) => section.id).join(',');
            const cacheBuster = new Date().getTime();
            fetch(`${window.routes.cart_url}?sections=${sectionsToRender}&t=${cacheBuster}`)
              .then(res => res.json())
              .then(parsedState => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-items', // Prevent redundant GET
                  cartData: response, // Keep original response for cartUpdate
                });
                cart.renderContents({ sections: parsedState, id: response.id });
              })
              .catch(console.error)
              .finally(() => {
                button.removeAttribute('aria-disabled');
                button.classList.remove('loading');
              });
          }, 1500);
          return; // Skip finally block below because we handle it inside setTimeout
        }
      })
      .catch((error) => {
        console.error(error);
        showMissingOptions(slide);
      })
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  };

  const initBundleSection = (root) => {
    if (!root || root.dataset.nazvaProductBundlesReady === 'true') return;
    root.dataset.nazvaProductBundlesReady = 'true';

    const track = root.querySelector(selectors.track);
    const slides = Array.from(root.querySelectorAll(selectors.slide));
    const summaries = Array.from(root.querySelectorAll(selectors.summary));
    const prev = root.querySelector(selectors.prev);
    const next = root.querySelector(selectors.next);
    const dots = Array.from(root.querySelectorAll(selectors.dot));
    const usesNativeTouchScroll = () =>
      window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(hover: none)').matches;
    let currentIndex = 0;
    let dragState = null;
    let suppressClick = false;
    let suppressClickTimer;

    const updateCarousel = () => {
      if (!track || !slides.length) return;
      currentIndex = Math.max(0, Math.min(currentIndex, slides.length - 1));
      track.classList.remove('is-dragging');
      if (!usesNativeTouchScroll()) {
        track.style.removeProperty('scroll-snap-type');
        track.style.removeProperty('scroll-padding-left');
        track.style.removeProperty('transform');
        track.style.setProperty('--nazva-bundle-active-slide', String(currentIndex));
      }
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === currentIndex));
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === currentIndex));
      summaries.forEach((summary) => {
        const summaryIndex = slides.findIndex((slide) => slide.dataset.bundleId === summary.dataset.bundleId);
        summary.classList.toggle('is-active', summaryIndex === currentIndex);
      });
      if (prev) prev.disabled = currentIndex <= 0;
      if (next) next.disabled = currentIndex >= slides.length - 1;
    };

    const scrollToSlide = (index) => {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (usesNativeTouchScroll()) {
        const targetSlide = slides[currentIndex];
        targetSlide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      updateCarousel();
    };

    const syncIndexFromScroll = () => {
      if (!usesNativeTouchScroll() || !track || !slides.length) return;
      const slideWidth = slides[0]?.clientWidth || track.clientWidth || 1;
      const nextIndex = Math.round(track.scrollLeft / slideWidth);
      if (nextIndex === currentIndex) return;
      currentIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
      updateCarousel();
    };

    const finishDrag = (event) => {
      if (!dragState) return;

      const movedBy = dragState.currentX - dragState.startX;
      const threshold = Math.min(140, dragState.slideWidth * 0.14);

      if (event && track.hasPointerCapture?.(dragState.pointerId)) {
        track.releasePointerCapture(dragState.pointerId);
      }

      track.classList.remove('is-dragging');

      if (Math.abs(movedBy) > threshold) {
        scrollToSlide(currentIndex + (movedBy < 0 ? 1 : -1));
      } else {
        updateCarousel();
      }

      suppressClick = dragState.didDrag;
      dragState = null;

      if (suppressClick) {
        window.clearTimeout(suppressClickTimer);
        suppressClickTimer = window.setTimeout(() => {
          suppressClick = false;
        }, 350);
      }
    };

    root.addEventListener('click', (event) => {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
        return;
      }

      const addButton = event.target.closest(selectors.add);
      if (addButton) {
        event.preventDefault();
        const bundleId = addButton.dataset.bundleId;
        const activeSlide = bundleId
          ? slides.find((slide) => slide.dataset.bundleId === bundleId)
          : root.querySelector(`${selectors.slide}.is-active`);
        if (!activeSlide) return;
        addBundleToCart(root, activeSlide, addButton);
      }
    });

    root.addEventListener('change', (event) => {
      if (!event.target.matches(selectors.variant)) return;
      const productElement = event.target.closest(selectors.product);
      productElement?.classList.remove('has-missing-options');
      calculateSlide(root, event.target.closest(selectors.slide));
    });

    if (!usesNativeTouchScroll()) {
      track?.addEventListener('pointerdown', (event) => {
        if (slides.length <= 1 || isInteractiveBundleTarget(event.target)) {
          return;
        }

        const slideWidth = root.querySelector('.nazva-product-bundles__viewport')?.clientWidth || track.clientWidth || 1;
        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          currentX: event.clientX,
          slideWidth,
          didDrag: false,
          hasCaptured: false,
        };
      });

      track?.addEventListener('pointermove', (event) => {
        if (!dragState || dragState.pointerId !== event.pointerId) return;

        dragState.currentX = event.clientX;
        const deltaX = dragState.currentX - dragState.startX;

        if (Math.abs(deltaX) > 6) {
          dragState.didDrag = true;
        }

        if (!dragState.didDrag) return;

        event.preventDefault();

        if (!dragState.hasCaptured) {
          track.setPointerCapture?.(event.pointerId);
          track.classList.add('is-dragging');
          dragState.hasCaptured = true;
        }

        track.style.transform = `translateX(calc(${currentIndex * -100}% + ${deltaX}px))`;
      });

      track?.addEventListener('pointerup', finishDrag);
      track?.addEventListener('pointercancel', finishDrag);
      track?.addEventListener('pointerleave', (event) => {
        if (!dragState || dragState.pointerId !== event.pointerId || dragState.didDrag === false) return;
        finishDrag(event);
      });
    } else {
      let scrollFrame;
      track?.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(syncIndexFromScroll);
      });
    }

    prev?.addEventListener('click', () => {
      scrollToSlide(currentIndex - 1);
    });

    next?.addEventListener('click', () => {
      scrollToSlide(currentIndex + 1);
    });

    dots.forEach((dot) => dot.addEventListener('click', () => scrollToSlide(Number(dot.dataset.nazvaBundleDot || 0))));

    slides.forEach((slide) => calculateSlide(root, slide));
    updateCarousel();
    window.addEventListener('resize', updateCarousel);
  };

  const initAll = () => document.querySelectorAll(selectors.root).forEach(initBundleSection);

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(selectors.root).forEach(initBundleSection);
  });
})();




